
<template>
<div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div class="header">
            <h2>
              <strong>필드 타입</strong>
              <small
                >유저에게 보여줄 필드를 추가하세요. Computed 필드는 유저에게
                보이지 않습니다.</small
              >
            </h2>
          </div>
          <div class="body">
            <div class="row clearfix">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="c_radio" for="fieldRadio">
                    <input
                      type="radio"
                      name="radio1"
                      id="fieldRadio"
                      v-model="field"
                      value="field"
                      checked=""
                    />
                    <span class="checkmark"></span>
                    <span class="ml-2">필드</span>
                  </label>
                </div>
                <div class="form-group">
                  <label class="c_radio" id="computedRadio">
                    <input
                      type="radio"
                      name="radio1"
                      id="computedRadio"
                      v-model="field"
                      value="computed"
                    />
                    <span class="checkmark"></span>
                    <span class="ml-2">Computed 필드</span>
                  </label>
                  <!--                                                                           
                                       <input id="field" name="type" type="radio" value="0" v-model="choice">
                                        <label for="field">Field </label>
                                        &nbsp;&nbsp;&nbsp;
                                        <input id="Computefield" name="type" type="radio" value="1" v-model="choice">
                                        <label for="Computefield">computed Field </label>
                                        <br>선택한 필드 : {{choice}} -->
                </div>
              </div>
            </div>


            <h2 class="card-inside-title">키 (필수)</h2>
            <div class="row clearfix">
              <div class="col-sm-12">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="key"
                    placeholder="필드 키 입력"
                  />
                </div>
              </div>
              <div class="col-sm-12">
                <!-- <div class="body"> -->
                <div class="mb-3">
                  <label class="c_checkbox">
                    <input type="checkbox" v-model="required" />
                    <span class="checkmark"></span>
                    <span class="ml-2">필수인가요?</span>
                  </label>
                </div>
                <!-- </div> -->
              </div>
            </div>

            
            <h2 class="card-inside-title" v-if="field == 'field'">
              라벨 (선택)
            </h2>
            <div class="row clearfix" v-if="field == 'field'">
              <div class="col-sm-12">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="label"
                    placeholder="사용자가 알아볼 수 있는 라벨"
                  />
                </div>
              </div>
            </div>

            <h2 class="card-inside-title">타입 (선택)</h2>
            <div class="row clearfix">
              <div class="col-sm-12">
                <select class="form-control show-tick" v-model="types">
                  <option value="">--선택--</option>
                  <option value="string">String</option>
                  <option value="password">Password</option>
                </select>
              </div>
            </div>
            <h2 class="card-inside-title" v-if="field == 'field'">
              도움말 (선택)
            </h2>
            <div class="row clearfix" v-if="field == 'field'">
              <div class="col-sm-12">
                <textarea
                  id="helpText"
                  v-model="description"
                  placeholder=""
                  style="width: 100%; height: 80px"
                ></textarea>
              </div>
            </div>

            <h2 class="card-inside-title" v-if="field == 'field'">
              입력폼 (선택)
            </h2>
            <div class="row clearfix" v-if="field == 'field'">
              <div class="col-sm-12">
                <div class="form-group">
                  <input
                    type="text"
                    v-model="form"
                    class="form-control"
                    placeholder="http://"
                  />
                </div>
              </div>
            </div>

            <h2 class="card-inside-title">기본 폼 (선택)</h2>
            <div class="row clearfix">
              <div class="col-sm-12">
                <div class="form-group">
                  <input
                    type="text"
                    v-model="format"
                    class="form-control"
                    placeholder="사용자에게 친근한 이름 입력"
                  />
                </div>
              </div>
            </div>

            <!-- <h2 class="card-inside-title" v-if="field == 'field'">
              static dropdownt (optional)
            </h2>
            <div class="row clearfix" v-if="field == 'field'">
              <div class="col-sm-12">
                <div class="form-group">
                  <dev-code-mode />
                </div>
              </div>
            </div> -->

            <div style="text-align: right; margin-bottom: 10px">
              <button type="button" class="btn btn-primary" @click="toPreviousPage(0)">
                저장
              </button>
              <button type="button" class="btn btn-default" @click="toPreviousPage(1)">
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #END# Input -->
  </div>
</template>

<script>
export default {
  name: "DevAuthField",
  data() {
    return {
      field: "field",
      sendingType: "",
      fieldsText: "",

      noun: null,
      key: null,
      label: null,
      types: null,
      description: null,
      form: null,
      format: null,
      required: false,

      oldText: null,
    };
  },
  methods: {
    toPreviousPage(num) {
      if (num == 0) {
        if (this.key == null || this.key == "" || this.key == "null") {
          alert("키를 입력해주세요.");
          return;
        }

        ``;
        var map = new Map();

        if (this.oldText == null) {
          if (this.key != null && this.key != "null" && this.key != "") {
            map.set(this.key, "{{bundle.authData." + this.key + "}}");
          }
        } else {
          if (this.key != null && this.key != "null" && this.key != "") {
            map.set("oldText", this.oldText);
            map.set(this.key, "{{bundle.authData." + this.key + "}}");
          }
        }

        var reqCheck = 0;
        if (this.required == true) {
          reqCheck = 1;
        }
        ``;

        var param = {
          appCode: this.$store.state.devStore.appCode,
          apiCode: this.$store.state.devStore.apiCode,

          checkType: this.field,
          where: "field",

          index: this.$route.params.fieldnum,
          keys: this.key,
          label: this.label,
          types: this.types,
          description: this.description,
          form: this.form,
          format: this.format,
          requireText: reqCheck,

          apiSchema: JSON.stringify(Object.fromEntries(map)),
        };

        this.api.configSchema(param)
          .then((res) => {
            console.log("저장 : ", res);

            this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
            .then((res)=>{
              this.$store.dispatch("apiDetail", {result : res}).then(() => {
                this.$router.push({
                  name: "DevAuthSetting",
                  params: {},
                });
              });

            })

          })
          .catch(() => alert("오류가 발생했습니다. auth fields"));
      } else if (num == 1) {
        this.$router.push({
          name: "DevAuthSetting",
          params: {},
        });
      }
    },
    dontLikeNull(value) {
      if (value.includes("null")) {
        return "";
      } else {
        return value;
      }
    },
  },
  created() {
    console.log("DevAuthField.created");
    if (this.$route.params.fieldnum != 1) {
      this.key = this.$store.state.devStore.apiSchema.keys.replace(/"/gi, "");
      this.oldText = this.$store.state.devStore.apiSchema.keys.replace(
        /"/gi,
        ""
      );
      this.label = this.dontLikeNull(
        this.$store.state.devStore.apiSchema.label.replace(/"/gi, "")
      );

      if (
        this.dontLikeNull(this.$store.state.devStore.apiSchema.require).replace(
          /"/gi,
          ""
        ) == 1
      ) {
        this.required = true;
      }

      this.types = this.dontLikeNull(
        this.$store.state.devStore.apiSchema.type.replace(/"/gi, "")
      );
      this.description = this.dontLikeNull(
        this.$store.state.devStore.apiSchema.description.replace(/"/gi, "")
      );
      this.form = this.dontLikeNull(
        this.$store.state.devStore.apiSchema.form.replace(/"/gi, "")
      );
      this.format = this.dontLikeNull(
        this.$store.state.devStore.apiSchema.format.replace(/"/gi, "")
      );
    }
  },
  mounted() {
    console.log("DevAuthField.mounted");
  },
  beforeDestroy() {
    console.log("DevAuthField.beforeDestroy");
  }
}
</script>
